export const checkboxMap = {
  lg: {
    IconCheck: 'baseX24/ic-check',
    indeterminateWidth: 13.7,
  },
  md: {
    IconCheck: 'baseX24/ic-check',
    indeterminateWidth: 13.7,
  },
  sm: {
    IconCheck: 'baseX24/ic-check',
    indeterminateWidth: 13.7,
  },
  xs: {
    IconCheck: 'baseX16/ic-check',
    indeterminateWidth: 10,
  },
} as const
